export default "__VITE_ASSET__vYKYTPtZ__"